import { render } from "./Agreement.vue?vue&type=template&id=0a9e21d2&scoped=true"
const script = {}

import "./Agreement.vue?vue&type=style&index=0&id=0a9e21d2&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9e21d2"]])

export default __exports__